<template>
  <div class="categoryPrint-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            分类打印
          </div>
          <div class="card-content" v-loading="loading">
            <el-form :inline="true" size="small" :model="searchForm">
              <el-form-item label="区域">
                <el-select v-model="searchForm.area" filterable clearable>
                  <el-option
                    v-for="item in orderinfo.arealst"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分类">
                <el-select v-model="searchForm.type" style="width: 100px" filterable clearable>
                  <el-option
                    v-for="item in orderinfo.typelst"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="搜索关键字">
                <el-input v-model="searchForm.search"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getMaterialDetail" icon="el-icon-search">筛选</el-button>
                <el-button @click="print(0)" icon="el-icon-printer">打印</el-button>
<!--                <el-button @click="print(1)" icon="el-icon-document">打印木工房门组料单</el-button>-->
              </el-form-item>
            </el-form>
            <div style="padding-top: 50px;border-top: 1px solid #f5f7fa;margin-top:30px;">
              <el-form size="small" :model="printForm" label-width="80px">
                <el-row>
                  <el-col :span="6">
                    <div class="order-logo" :style="{backgroundImage: 'url(' + printForm.order_logo + ')' }"></div>
                  </el-col>
                  <el-col :span="12" style="padding: 0 10px">
                    <el-form-item class="print-title">
                      <el-input v-model="printForm.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item class="print-row-num">
                      <el-col :span="8">
                        <el-input v-model="printForm.num"></el-input>
                      </el-col>
                      <el-col style="padding-left: 10px" :span="3">件</el-col>
                      <el-col style="padding-right: 10px;text-align: right" :span="3">共</el-col>
                      <el-col :span="8">
                        <el-input v-model="printForm.row"></el-input>
                      </el-col>
                      <el-col style="padding-left: 10px" :span="2">行</el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="单号">
                      <el-input  v-model="printForm.produnum"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="工艺">
                      <el-input  v-model="printForm.source"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="设计师">
                      <el-input  v-model="printForm.designer"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="接单日期">
                      <el-date-picker
                        v-model="printForm.receive_time"
                        type="date"
                        style="width: 100%"
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="排产日期">
                      <el-date-picker
                        v-model="printForm.schedule_time"
                        type="date"
                        style="width: 100%"
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="订单号">
                      <el-input  v-model="printForm.ordernum"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="经销商">
                      <el-input :value="orderinfo.dealerInfo && orderinfo.dealerInfo.allname + (orderinfo.dealerInfo && orderinfo.dealerInfo.vip == 1 ? '(VIP)' : '')" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="地址">
                      <el-input  v-model="printForm.address"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="拆单日期">
                      <el-date-picker
                        v-model="printForm.split_time"
                        type="date"
                        style="width: 100%"
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="预计交期">
                      <el-date-picker
                        v-model="printForm.planned"
                        type="date"
                        style="width: 100%"
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div style="height: 490px;width: 100%" v-loading="materialloading">
              <pl-table
                height="490px"
                :datas="materialTableData"
                :data="materialTableData"
                border
                size="small"
                use-virtual
                :pagination-show="false"
                :row-height="45">
                <pl-table-column prop="xuhao" label="序号" width="80"></pl-table-column>
                <pl-table-column prop="area" label="区域" width="100"></pl-table-column>
                <pl-table-column prop="type" label="分类" width="80"></pl-table-column>
                <pl-table-column prop="name" label="名称" width="160"></pl-table-column>
                <pl-table-column prop="material" label="基材" width="80"></pl-table-column>
                <pl-table-column prop="high" label="高/长" width="70"></pl-table-column>
                <pl-table-column prop="width" label="宽" width="70"></pl-table-column>
                <pl-table-column prop="lwidth" label="L宽" width="70"></pl-table-column>
                <pl-table-column prop="ply" label="厚" width="70"></pl-table-column>
                <pl-table-column prop="num" label="数量" width="70"></pl-table-column>
                <pl-table-column prop="val" label="数值" width="70"></pl-table-column>
                <pl-table-column prop="unit" label="单位" width="70"></pl-table-column>
                <pl-table-column prop="color" label="颜色" width="140"></pl-table-column>
                <pl-table-column prop="remark" label="备注" min-width="160"></pl-table-column>
              </pl-table>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpOrderCategoryPrint, getErpOrderMaterialDetail, ErpOrderCategoryPrint } from '@/api/erp'
import order_logo from '@/assets/order_logo.png'
import order_logo_sz from '@/assets/order_logo_sz.png'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'CategoryPrint',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      orderid: '',
      loading: false,
      materialloading: false,
      materialTableData: [],
      orderinfo: [],
      searchForm: {
        area: '',
        type: '',
        search: ''
      },
      printForm: {
        bid: 1,
        name: '乔金斯生产单',
        num: '0',
        row: '0',
        produnum: '',
        ordernum: '',
        designer: '',
        source: '',
        address: '',
        receive_time: '',
        split_time: '',
        schedule_time: '',
        planned: '',
        order_logo: ''
      }
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.orderid = this.$route.params && this.$route.params.id
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading = true
      getErpOrderCategoryPrint({ orderid: this.orderid }).then(response => {
        this.orderinfo = response.data || {}
        const pageTitle = `分类打印 ${response.data.produnum}`
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        this.printForm.produnum = this.orderinfo.produnum
        this.printForm.ordernum = this.orderinfo.ordernum
        if (this.orderinfo.produnum.indexOf('SZ') >= 0) {
          this.printForm.name = '首造生产单'
          this.printForm.order_logo = order_logo_sz
          this.printForm.bid = 3
        } else {
          this.printForm.order_logo = order_logo
        }
        if (this.orderinfo.dealerInfo && this.orderinfo.dealerInfo.vip == 1) {
          this.printForm.name += '(VIP)'
        }
        this.printForm.designer = this.orderinfo.designer
        if (this.orderinfo.source === 1) {
          this.printForm.source = '客户提供色板'
        } else if (this.orderinfo.source === 2) {
          this.printForm.source = '厂部定制色板'
        } else {
          this.printForm.source = '厂部标准色板'
        }
        this.printForm.address = this.orderinfo.address
        this.printForm.receive_time = this.orderinfo.receive_time
        this.printForm.split_time = this.orderinfo.split_time
        this.printForm.schedule_time = this.orderinfo.schedule_time
        this.printForm.planned = this.orderinfo.planned
        this.loading = false
        this.getMaterialDetail()
      }).catch(() => {
        this.loading = false
      })
    },
    getMaterialDetail() {
      this.materialTableData = []
      this.materialloading = true
      const data = {
        orderid: this.orderid,
        area: this.searchForm.area,
        type: this.searchForm.type,
        content: this.searchForm.search,
        groupid: this.user.dGroupid,
        factoryid: this.$route.query.data
      }
      getErpOrderMaterialDetail(data).then(response => {
        this.materialTableData = response.data
        this.printForm.row = this.materialTableData.length
        let num = 0
        for (let m of this.materialTableData) {
          if (m.num !== null && m.num !== '' && m.num !== undefined) {
            num += parseInt(m.num)
          }
        }
        this.printForm.num = num
        this.materialloading = false
      }).catch(() => {
        this.materialloading = false
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        let tempindex = 0
        let rowspan = 1
        let temp = null
        for (let i = 0; i <= this.materialTableData.length; i++) {
          if (i === 0) {
            tempindex = i
            rowspan = 1
            temp = this.materialTableData[i].area
          } else {
            if (i === this.materialTableData.length) {
              if (rowIndex === tempindex) {
                return {
                  rowspan: rowspan,
                  colspan: 1
                }
              }
            } else {
              if (temp === this.materialTableData[i].area) {
                rowspan++
                if (rowIndex === i) {
                  return {
                    rowspan: 0,
                    colspan: 0
                  }
                }
              } else {
                if (rowIndex === tempindex) {
                  return {
                    rowspan: rowspan,
                    colspan: 1
                  }
                } else {
                  tempindex = i
                  rowspan = 1
                  temp = this.materialTableData[i].area
                }
              }
            }
          }
        }
      }
    },
    print(n) {
      let LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (!this.fullscreenLoading) {
          this.fullscreenLoading = true
          let d_title = this.printForm.name
          if (n === 1) {
            d_title = '木工房门组生产单'
          }
          const data = {
            d_title: d_title,
            d_zjs: this.printForm.num,
            d_zhs: this.printForm.row,
            d_dh: this.printForm.produnum,
            d_gy: this.printForm.source,
            d_sjs: this.printForm.designer,
            d_xsbjdrq: this.printForm.receive_time,
            d_xdscrq: this.printForm.schedule_time,
            d_ydh: this.printForm.ordernum,
            d_dz: this.printForm.address,
            d_sjscdrq: this.printForm.split_time,
            d_yjjhrq: this.printForm.planned,
            area: this.searchForm.area,
            type: this.searchForm.type,
            search: this.searchForm.search,
            mgtype: n,
            orderid: this.orderid
          }
          ErpOrderCategoryPrint(data).then(response => {
            this.fullscreenLoading = false
            LODOP.PRINT_INIT(`${this.printForm.bid === 3 ? '首造' : '乔金斯'}生产单打印`)
            LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4')
            LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
            LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
            LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
            LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
            LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
            LODOP.NewPageA()
            LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
            LODOP.PREVIEW()
          }).catch(() => {
            this.fullscreenLoading = false
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.categoryPrint-container{
  .order-logo{
    margin-top: 5px;
    width: 100%;
    height: 40px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 100%;
  }
}
</style>
